import { cn } from "@/lib/utils";

import type { FieldEvidence } from "../types";

const STAMP_STYLE: Record<FieldEvidence["method"], string> = {
  extracted: "border-measured text-measured",
  inferred: "border-inferred text-inferred-ink",
  entered: "border-border text-muted-foreground",
};

/** Tampon du procès-verbal : dit d'où vient un chiffre (cité dans la source, déduit par l'IA, saisi). */
export const MethodStamp = ({
  method,
  label,
  title,
  className,
}: {
  method: FieldEvidence["method"];
  label: string;
  title?: string;
  className?: string;
}) => (
  <span
    title={title}
    className={cn(
      "shrink-0 whitespace-nowrap rounded-[3px] border px-1.5 text-[11px] font-bold uppercase leading-4 tracking-[0.08em]",
      STAMP_STYLE[method],
      className,
    )}
  >
    {label}
  </span>
);
